import { GSS_ACCOUNTS } from "@/utils/helpers/mappings"

type AccountProduct = {
  productId: number
}

/** GESB-631: bank details are not maintained in MOL for GSS-only profiles. */
export function memberHasOnlyGssAccounts(
  accounts: readonly AccountProduct[]
): boolean {
  return (
    accounts.length > 0 &&
    accounts.every((account) =>
      (GSS_ACCOUNTS as readonly number[]).includes(account.productId)
    )
  )
}
